/**
 * Draws the cropped image preview on a canvas.
 * @param {HTMLImageElement} image - The source image.
 * @param {HTMLCanvasElement} canvas - The canvas element to draw the preview on.
 * @param {Object} crop - The crop object containing width, height, x, and y.
 * @param {number} scale - The scale factor for the image.
 * @param {number} rotate - The rotation angle for the image.
 */
export function canvasPreview(image, canvas, crop, scale = 1, rotate = 0) {
    const ctx = canvas.getContext('2d');
  
    if (!ctx) {
      throw new Error('No 2d context');
    }
  
    // Calculate scaling factors for the image
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
  
    // Set canvas dimensions to match the crop dimensions
    canvas.width = Math.floor(crop.width * scaleX);
    canvas.height = Math.floor(crop.height * scaleY);
  
    ctx.save();
    ctx.scale(scale, scale);
  
    // Translate to the crop area
    ctx.translate(-crop.x * scaleX, -crop.y * scaleY);
  
    // Apply rotation if needed
    ctx.translate(canvas.width / 2, canvas.height / 2);
    ctx.rotate((rotate * Math.PI) / 180);
    ctx.translate(-canvas.width / 2, -canvas.height / 2);
  
    // Draw the cropped area of the image onto the canvas
    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      canvas.width,
      canvas.height
    );
  
    ctx.restore();
  }